import ReduxStore from '../../../ReduxStore';
import has from 'lodash/has';
import get from 'lodash/get';

export const hasSelectedNotes = (id, keyPath) => {
  const {propertyNotes} = ReduxStore.getState();
  return has(propertyNotes, `${id}.${keyPath}`) && get(propertyNotes, `${id}.${keyPath}`) === true;
};